import { FC } from 'react';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';

import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import { useTranslation } from 'helpers/languages/translations';
import ShopClusterToolbar from './ShopClusterToolbar';
import useShopClusterContainer from './ShopClusterContainer';
import ShopClusterActionModal from './ShopClusterActionModal';

const ShopClusterViewer: FC<{ toolId: number }> = ({ toolId }) => {
    const props = useShopClusterContainer();
    const translate = useTranslation();
    const {
        isLoading,
        table,
        selectedRetailers,
        actionModalProps,
        actionModalType,
        setActionModalType,
        currentShop,
    } = props;

    return (
        <Box mt="16px">
            <ShopClusterToolbar {...props} />
            {isLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    {selectedRetailers?.length ? (
                        <DITable table={table} isPagination />
                    ) : (
                        <Flex
                            h={100}
                            bg="white"
                            align="center"
                            justifyContent="center"
                            border="1px solid"
                            borderColor="gray.100"
                        >
                            <Text fontSize="md">{translate(`secto.viewer.table.retailer`)}</Text>
                        </Flex>
                    )}
                    <TablePagination table={table} />
                    <ShopClusterActionModal
                        {...actionModalProps}
                        setActionModalType={setActionModalType}
                        actionModalType={actionModalType}
                        currentShop={currentShop}
                    />
                </>
            )}
        </Box>
    );
};

export default ShopClusterViewer;
